import Explorer from "./Explorer";
import messages from "box-ui-elements/i18n/en-US";
import Lottie from "react-lottie";
import animationData from "./loading.json";

function MM({ boxAccessToken }) {
  const FILE_ID_DOC = "387562652404";
  const explorerProps = {
    token: boxAccessToken,
    language: "en-US",
    messages: messages,
    rootFolderId: "0",
    currentFolderId: FILE_ID_DOC,
    logoUrl: "box",
    canCreateNewFolder: true,
    canDelete: true,
    canDownload: true,
    canPreview: true,
    canRename: true,
    canSetShareAccess: false,
    canShare: false,
    canUpload: true,
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="NSC-MM">
      <div className="NSC-MM-content">
        <h1 className="NSC-MM-title">
          Meeting Materials&nbsp;
          <span className="NSC-MM-title-lowercase">(READ-ONLY)</span>
        </h1>
        <div className="NSC-MM-files">
          {!boxAccessToken ? (
            <Lottie options={defaultOptions} height={200} width={200} />
          ) : (
            <Explorer {...explorerProps} />
          )}
        </div>
      </div>
    </div>
  );
}

export default MM;
